let telegram = null;

export const getTelegramInstance = () => {
    console.log('getTelegramInstance', `window.Telegram.WebApp: ${window.Telegram?.WebApp}`)
    //logger.log(`getTelegramInstance, window.Telegram.WebApp: ${window.Telegram?.WebApp}`)
    if (!telegram && window.Telegram?.WebApp) { telegram = window.Telegram.WebApp; }
    return telegram;
};

export const initTelegram = () => {
    const tg = getTelegramInstance();
    if (tg) {
        //TODO off debug
        tg.debug = false
        tg.ready();
        console.log('Telegram WebApp initialized')
    } else { console.warn('initTelegram', 'Telegram WebApp недоступен') }
};

// Получить данные пользователя
export const getTelegramUser = () => {
    const tg = getTelegramInstance();
    return tg?.initDataUnsafe?.user || null;
};

export const getInitData = () => {
    const tg = getTelegramInstance();
    return tg?.initData || null;
}

// Показать кнопку "Назад"
let activeBackButtonHandler = null;

export const configureBackButton = () => {
    const tg = window.Telegram?.WebApp;
    if (!tg) {
        console.warn('[Telegram] WebApp SDK is not available');
        return null;
    }
    return tg.BackButton;
};

export const showBackButton = () => {
    const backButton = configureBackButton();
    if (backButton) backButton.show();
};

export const hideBackButton = () => {
    const backButton = configureBackButton();
    if (backButton) backButton.hide();
};

export const setBackButtonHandler = (handler) => {
    const backButton = configureBackButton();

    if (!backButton) return;

    // Удаляем старый обработчик, если он существует
    if (activeBackButtonHandler) {
        backButton.offClick(activeBackButtonHandler);
    }

    // Назначаем новый обработчик
    activeBackButtonHandler = () => {
        console.warn('[Telegram] Back button clicked');
        handler();
    };
    backButton.onClick(activeBackButtonHandler);
};

export const clearBackButtonHandler = () => {
    const backButton = configureBackButton();
    if (backButton && activeBackButtonHandler) {
        backButton.offClick(activeBackButtonHandler);
        activeBackButtonHandler = null;
    }
};

// Проверка доступности Telegram WebApp SDK
export const isTelegramAvailable = () => !!getTelegramInstance();

// Закрыть приложение
export const closeTelegram = () => {
    const tg = getTelegramInstance();
    if (tg) {
        tg.close();
    } else {
        console.warn('Telegram WebApp недоступен');
    }
};
